export default function PHP_ReferenceFTP() {
  return (
    <div>
      <h1>PHP_ReferenceFTP</h1>
    </div>
  );
}
